import { createFileRoute } from "@tanstack/react-router";
import PaymentsLedger from "@/pages/admin/PaymentsLedger";
import { MainLayout } from "@/components/layout/MainLayout";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";

export const Route = createFileRoute("/admin/payments")({
  head: () => ({
    meta: [
      { title: "Payments & Credit Ledger | Statlign Admin" },
      { name: "description", content: "Inspect Paystack webhook deliveries, idempotency keys, retry status, credit grants and refunds for Premium and Wallet." },
      { property: "og:title", content: "Payments & Credit Ledger | Statlign Admin" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "Inspect Paystack webhook deliveries, idempotency keys, retry status, credit grants and refunds for Premium and Wallet." },
      { name: "twitter:title", content: "Payments & Credit Ledger | Statlign Admin" },
      { name: "twitter:description", content: "Inspect Paystack webhook deliveries, idempotency keys, retry status, credit grants and refunds for Premium and Wallet." },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => (
    <MainLayout>
      <ProtectedRoute requiredRole="admin">
        <PaymentsLedger />
      </ProtectedRoute>
    </MainLayout>
  ),
});
